<template>
  <div class="lightbox">
    <img v-if="showLoader" class="spin" :src="loadingSpinner" />
    <button
      v-if="showAddPaymentBtn"
      @click="getTokens"
      class="payment-form__submit-btn"
      type="submit"
    >
      Add Payment Information
    </button>
    <div :class="[{'visibility-none' : !showLightbox }]">
      <legend class="legend">Payment Information</legend>
      <iframe id="id_payment"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as Sentry from '@sentry/vue'
import convergeConfig from '@/config/converge'
import config from '@/config'
const { cdn } = config

export default {
  props: ['formCriteriaMet', 'firstName', 'lastName', 'address', 'billingAddress2', 'zip', 'billingCustomerServiceAgreement', 'onLightboxInitiated'],
  data () {
    return {
      showAddPaymentBtn: true,
      loadingSpinner: `${cdn}icons-spinner-loading.svg`,
      showLoader: false,
      convergeConfig,
      authToken: '',
      sessionToken: '',
      showLightbox: false,
      lightboxTimeout: null
    }
  },
  methods: {
    getTokens () {
      this.onLightboxInitiated()
      const form = document.getElementById('paymentForm')
      const isValid = form.reportValidity()
      if (!isValid) return

      this.$emit('submit-events')
      this.showAddPaymentBtn = false
      this.showLoader = true
      // TODO: replace this with hubRequest from utilities.js
      return axios.post(`${process.env.VUE_APP_SERVER}/api/payment_tokens`)
        .then(({ data }) => {
          const { authToken, sessionToken } = data
          this.authToken = authToken
          this.sessionToken = sessionToken
          this.initialize()
        })
        .catch(e => {
          Sentry.withScope(scope => {
            scope.setTag('netsuite_pay', 'payment_tokens')
            scope.setLevel('fatal')
            Sentry.captureException(e)
          })
          console.log(e)
        })
    },
    initialize () {
      // Give lightbox 10 seconds to load before reporting an error
      this.lightboxTimeout = setTimeout(() => {
        Sentry.withScope(scope => {
          scope.setTag('lightbox', 'init_failure')
          scope.setLevel('fatal')
          Sentry.captureException(new Error('Lightbox failed to initialize'))
        })
      }, 10000)
      this.openLightbox()
    },
    buildConvergeCCTokenParams () {
      return {
        ssl_add_token: 'Y',
        ssl_avs_address: this.address,
        ssl_avs_zip: this.zip,
        ssl_card_present: 'N',
        ssl_first_name: this.firstName,
        ssl_last_name: this.lastName,
        ssl_transaction_type: 'ccgettoken',
        ssl_txn_auth_token: this.sessionToken
      }
    },
    openLightbox () {
      window.PayWithConverge.open(
        this.buildConvergeCCTokenParams(),
        {
          onApproval: (convergeResponse) => {
            console.log('Lightbox - onApproval')
            this.$emit('lightbox-approval', {
              convergeResponse,
              authToken: this.authToken
            })
          },
          // Fires on lightbox session timeout of 15 minutes
          onCancelled: (error) => {
            console.log('Lightbox - onCancelled')
            this.$emit('lightbox-cancelled', error)
          },
          // Fired when user selects cancel after declined card
          onDeclined: (response) => {
            console.log('Lightbox - onDeclined')
            this.$emit('lightbox-declined', response)
          },
          // Could never get this to fire and there are no Converge docs about it
          onError: (error) => {
            console.log('Lightbox - onError')
            Sentry.withScope(scope => {
              scope.setTag('lightbox', 'on_error')
              scope.setLevel('fatal')
              Sentry.captureException(new Error('Lightbox on_error'))
            })
            this.$emit('lightbox-error', error)
          },
          // Lightbox is ready to be displayed
          onReady: () => {
            console.log('Lightbox - onReady')
            clearTimeout(this.lightboxTimeout)
            this.showLoader = false
            this.showLightbox = true
          }
        }, {
          cssOverride:
          'html, body {overflow: hidden !important; width: 100% !important; height: 100% !important; background-color: rgba(0, 0, 0, 0);} ' +
          'form {padding: 0 !important;} ' +
          '.hpm-content {box-shadow: unset; padding:0; margin-top: unset; margin-left: 0; margin-right: 0;} ' +
          'md-card {box-shadow: unset; background-color: rgba(0, 0, 0, 0);} ' +
          ' .layout-padding {padding:0;} ' +
          'div span.ng-binding:before {content:"Place Your Order"; color:#FFF; font-size: 20px;} ' +
          'button.md-button.md-primary.md-raised {background-color:#e47d00; color:#FFF; padding: 10px 0;} ' +
          'button#id_recaptcha.md-button.md-primary.md-raised {box-shadow: none;} ' +
          'button#id_recaptcha.md-button.md-primary.md-raised:hover {background-color:#e47d00 !important;} ' +
          'button.md-button.md-primary.md-raised:active {background-color:#e47d00;} ' +
          'button.md-button.md-primary.md-raised:disabled {background-color:#DADADA;} ' +
          'button#id_recaptcha.md-button.md-primary.md-raised:disabled:hover {background-color:#DADADA !important;} ' +
          'md-input-container .md-input {background-color: #FFF; border-color: #DADADA; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3) !important;} ' +
          'md-input-container label {color:#AAAAAA; font-size: 15px !important;} ' +
          'md-dialog-content div h3 {text-align:center;} ' +
          'img[src="assets/images/cards/unionpay.png"] {display: none;} ' +
          'md-dialog md-dialog-actions {justify-content:center;} ',
          frame: document.getElementById('id_payment')
        }
      )
    }
  }
}
</script>
